export default "/images/e7c936c69bfbfd2e1789906180f94773.png";